import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Caret, Tr, Td } from "commons";

export function TableAccordion({ content }) {
    const [hidden, setHidden] = useState(true);

    const toggle = () => setHidden(v => !v);

    return (
        <Fragment>
            {!hidden && content}
            <Tr onClick={toggle}>
                <ControlsContainer colSpan="2">
                    <Controls>
                        <span>{hidden ? "View all" : "View less"}</span>
                        <Caret direction={hidden ? "down" : "up"} />
                    </Controls>
                </ControlsContainer>
            </Tr>
        </Fragment>
    );
}

const ControlsContainer = styled(Td)`
    color: ${props => props.theme.primary};
    text-align: center;
    cursor: pointer;
`;

const Controls = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media print {
        display: none;
    }
`;

TableAccordion.propTypes = {
    content: PropTypes.array
};
